// Remembers the page a signed-out visitor asked for, so a link from an email (NEA-6637)
// lands on that page after sign-in rather than on the Overview.

export const REDIRECT_PARAM = 'redirect';

// Only same-site paths. '//evil.com' and '/\evil.com' are protocol-relative to a browser, and
// URL parsing strips tabs and newlines first, so '/\t/evil.com' is too — hence the control-
// character check and the origin comparison, rather than prefix checks alone. Sending someone
// back to /login after logging in would just loop.
// eslint-disable-next-line no-control-regex
const UNSAFE_CHARACTERS = /[\u0000-\u001F\u007F\\]/;
const PROBE_ORIGIN = 'https://unify.invalid';

export const safeRedirectPath = (raw) => {
	if (typeof raw !== 'string' || !raw.startsWith('/') || raw.startsWith('//')) return '/';
	if (UNSAFE_CHARACTERS.test(raw)) return '/';
	let url;
	try {
		url = new URL(raw, PROBE_ORIGIN);
	} catch {
		return '/';
	}
	if (url.origin !== PROBE_ORIGIN) return '/';
	if (url.pathname === '/login' || url.pathname.startsWith('/login/')) return '/';
	return raw;
};

export const redirectTargetFrom = (searchParams) => safeRedirectPath(searchParams.get(REDIRECT_PARAM));

// Appends the redirect to a login-flow URL, leaving it untouched when the target is the
// root (the default anyway, and keeps the plain /login URL for the common case).
export const withRedirect = (path, target) => {
	if (!target || target === '/') return path;
	const separator = path.includes('?') ? '&' : '?';
	return `${path}${separator}${REDIRECT_PARAM}=${encodeURIComponent(target)}`;
};

export const loginPathFor = ({ pathname, search }) => withRedirect('/login', safeRedirectPath(`${pathname}${search || ''}`));
